"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMoveSlotOptionsResponseSchema = exports.moveSlotTargetSchema = exports.moveSlotTargetAttributesSchema = exports.getMoveSlotOptionsQuerySchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const event_schema_1 = require("../global/event.schema");
const agenda_slot_1 = require("./agenda-slot");
exports.getMoveSlotOptionsQuerySchema = zod_1.z.object({
    timezone: zod_1.z.string(),
    reservationId: zod_1.z.string().uuid().optional(),
});
exports.moveSlotTargetAttributesSchema = zod_1.z.object({
    from: zod_1.z.coerce.date(),
    to: zod_1.z.coerce.date(),
    periodOfTheDay: zod_1.z.enum(event_schema_1.periodsOfTheDay),
    type: agenda_slot_1.agendaSlotTypeSchema,
    officeName: zod_1.z.string(),
    doctorAttendingName: zod_1.z.string(),
    retrocessionRate: zod_1.z.number(),
    withAssistant: zod_1.z.boolean(),
});
exports.moveSlotTargetSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('agenda-slots'),
    attributes: exports.moveSlotTargetAttributesSchema,
});
exports.getMoveSlotOptionsResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.moveSlotTargetSchema),
    meta: zod_1.z.object({
        sourceSlotId: zod_1.z.string().uuid(),
        sourceSlotDate: zod_1.z.coerce.date(),
    }),
});
